import React, { Component, useContext, useEffect } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { PathInfo } from "@my-dld/contexts/AppContext";
import { PageContext } from "@my-dld/contexts/PageContext";
import { AppConstants } from "../configApp";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil, StringUtil } from "@eres/core";

interface Props extends RoutedViewProps {

}

interface State {

}


class BreadCrumb extends Component<Props, State> {

	static contextType = PageContext;
	context!: React.ContextType<typeof PageContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			paths: []
		};
	}


	render() {
		const { title, hideBreadCrumb } = this.context;
		if ( hideBreadCrumb ) return null;
		return (
			<>
                <nav className="breadcrumb-custom" aria-label="breadcrumb" id="skipcontent">
                    <div className="container">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a
                                href={AppConstants.rootUrlLocale}>{Strings.home}</a></li>
                            {this.context.paths && this.context.paths.map((value, index, array) => {
                                let classes = "breadcrumb-item";
                                const isLast = index === array.length - 1;
                                if (isLast) {
                                    classes = classes + " active";
                                }
                                return <li className={classes} key={index + ""}>
                                    <a
                                        href="#" onClick={e => {
                                            e.preventDefault();
                                            this.openPath(value, index);
                                        }}>{LocaleUtil.getLocalValue(value.label)}</a>
                                </li>;
                            })}
                            {!StringUtil.isEmptyStringOrNull(title) &&
                                <li className="breadcrumb-item active" aria-current="page">
                                    {title}
                                </li>}
                        </ol>
                    </div>
                </nav>
                <div className="container pb-3 hide">
                    {!StringUtil.isEmptyStringOrNull(title) && <h4 className="page-title-text">{title}</h4>}
                </div>
			</>
		);
	}

	openPath = ( p: PathInfo, ix: number ) => {
		if ( p.path ) this.props.history.replace( p.path! );
	};
}

export default BreadCrumb;


export function HideBC() {
	const ctx = useContext( PageContext );
	useEffect( () => {
		ctx.showBreadCrumb( false );
		return () => {
			ctx.showBreadCrumb( true );
		};
	}, [] );
	return <React.Fragment/>;
}
